var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolitican(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11237_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58807 23.4205C6.64886 23.7598 6.94446 23.9978 7.27746 23.9974L16.7202 24C17.0866 24 17.3876 23.7196 17.4203 23.3616C17.8109 21.2246 18.2621 19.0999 18.6821 16.9689H5.31657C5.73897 19.1198 6.19469 21.2638 6.58807 23.4205ZM4.68751 7.36611L6.06189 6.44628C6.38346 6.23089 6.46957 5.79556 6.25417 5.47399C6.03878 5.15243 5.60345 5.06636 5.28189 5.28176L3.64271 6.37878C3.42713 6.49892 3.28125 6.72908 3.28125 6.99341V9.09379H4.68751V7.36611ZM17.9382 6.44628L19.3126 7.36611V9.09379H20.7189V6.99341C20.7189 6.72912 20.573 6.49892 20.3574 6.37878L18.7182 5.28171C18.3967 5.06632 17.9613 5.15238 17.7459 5.47394C17.5305 5.79556 17.6166 6.23089 17.9382 6.44628Z",
    fill: "#43C1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.10478C13.4098 5.10478 14.5525 3.96204 14.5525 2.55239C14.5525 1.14274 13.4098 0 12.0001 0C10.5905 0 9.44775 1.14274 9.44775 2.55239C9.44775 3.96204 10.5905 5.10478 12.0001 5.10478Z",
    fill: "#43C1F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1407 10.5002H2.85938C2.47106 10.5002 2.15625 10.815 2.15625 11.2033V14.8596C2.15625 15.2479 2.47106 15.5627 2.85938 15.5627H21.1407C21.5291 15.5627 21.8439 15.2479 21.8439 14.8596V11.2033C21.8439 10.815 21.5291 10.5002 21.1407 10.5002ZM12.7006 13.0821C12.6745 13.4467 12.3713 13.7346 12 13.7346C11.6254 13.7346 11.32 13.4414 11.2989 13.072C11.2981 13.0585 11.2969 13.0451 11.2969 13.0315C11.2969 13.0177 11.2981 13.0042 11.2989 12.9907C11.3196 12.6317 11.609 12.3455 11.9694 12.3299C11.9796 12.3295 11.9897 12.3284 12 12.3284C12.0103 12.3284 12.0203 12.3295 12.0304 12.3299C12.3875 12.3452 12.6751 12.6261 12.7006 12.9805C12.7018 12.9974 12.7031 13.0143 12.7031 13.0315C12.7032 13.0486 12.7018 13.0653 12.7006 13.0821ZM17.3907 7.54806C17.3907 7.24046 17.1932 6.97904 16.9181 6.8836C16.1244 6.56119 15.3233 6.28646 14.509 6.08841C13.9099 5.94267 13.3082 5.84095 12.7032 5.79544V7.05699C12.7032 7.44531 12.3884 7.76012 12.0001 7.76012C11.6117 7.76012 11.2969 7.44531 11.2969 7.05699V5.79492C9.83222 5.90419 8.42708 6.33774 7.04886 6.89987C6.77731 7.01035 6.61273 7.27191 6.61263 7.54806L6.6094 9.09391H17.3907V7.54806Z",
    fill: "#43C1F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11237_1819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolitican);
export default __webpack_public_path__ + "static/media/politican.edfb9b41237d0756a2cc45eb407e4167.svg";
export { ForwardRef as ReactComponent };